// extracted by mini-css-extract-plugin
module.exports =  {"button-text":"_32bbee5fda--button-text--tvTrC"};